export default class NoVariableError extends Error {
  constructor(variable, ...params) {
    super(...params)
    this.variable = variable;
  }
}
